import { getUpcomingConcerts } from 'api/concerts';
import { getUpcomingMatches } from 'api/homepage';
import { ConcertResponse, MatchResponse } from 'api/responseTypes';
import { getUpcomingWorkshops } from 'api/workshops';
import { useQuery } from 'react-query';

export type EventCategory = 'all' | 'concerts' | 'workshops' | 'matches' | 'international';

export interface AllEventsData {
  concerts: ConcertResponse[];
  workshops: ConcertResponse[];
  matches: MatchResponse[];
}

export const useAllEventsQuery = () => {
  const { isLoading: isLoadingConcerts, data: concertsData } = useQuery(
    'upComingConcert',
    getUpcomingConcerts,
  );
  const { isLoading: isLoadingWorkshops, data: workshopsData } = useQuery(
    'upComingWorkshops',
    getUpcomingWorkshops,
  );
  const { isLoading: isLoadingMatches, data: matchesData } = useQuery(
    'upcomingMatches',
    getUpcomingMatches,
  );

  const isLoading = isLoadingConcerts || isLoadingWorkshops || isLoadingMatches;

  const data: AllEventsData | undefined =
    concertsData && workshopsData && matchesData
      ? {
          concerts: concertsData.items || [],
          workshops: workshopsData.items || [],
          matches: matchesData.items || [],
        }
      : undefined;

  return {
    isLoading,
    data,
  };
};
